<template>
  <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      d="M13.88 14.08H18.01C18.3 14.08 18.54 13.84 18.54 13.55C18.54 13.26 18.3 13.02 18.01 13.02H13.88C13.59 13.02 13.35 13.26 13.35 13.55C13.35 13.84 13.59 14.08 13.88 14.08Z"
      fill="black"
    />
    <path
      d="M19.09 2H5.67C4.75 2 4 2.75 4 3.67V20.54C4 21.45 4.75 22.21 5.67 22.21H19.19C20.06 22.15 20.76 21.42 20.76 20.53V3.67C20.76 2.75 20.01 2 19.09 2ZM19.71 20.54C19.71 20.88 19.43 21.16 19.09 21.16H5.67C5.33 21.16 5.05 20.87 5.05 20.53V3.67C5.05 3.33 5.33 3.05 5.67 3.05H19.09C19.43 3.05 19.71 3.33 19.71 3.67V20.54Z"
      fill="black"
    />
    <path
      d="M6.7 11.17H18.06C18.35 11.17 18.59 10.93 18.59 10.64C18.59 10.35 18.35 10.11 18.06 10.11H6.7C6.41 10.11 6.17 10.35 6.17 10.64C6.17 10.93 6.41 11.17 6.7 11.17Z"
      fill="black"
    />
    <path
      d="M18.06 15.94H10.56C10.27 15.94 10.03 16.18 10.03 16.47C10.03 16.76 10.27 17 10.56 17H18.06C18.35 17 18.59 16.76 18.59 16.47C18.59 16.18 18.35 15.94 18.06 15.94Z"
      fill="black"
    />
    <path
      d="M18.06 18.84H6.7C6.41 18.84 6.17 19.08 6.17 19.37C6.17 19.66 6.41 19.9 6.7 19.9H18.06C18.35 19.9 18.59 19.66 18.59 19.37C18.59 19.08 18.35 18.84 18.06 18.84Z"
      fill="black"
    />
    <path
      d="M18.06 4.31H6.7C6.41 4.31 6.17 4.54 6.17 4.83V7.74C6.17 8.03 6.41 8.27 6.7 8.27H18.06C18.35 8.27 18.58 8.03 18.58 7.74V4.83C18.58 4.54 18.35 4.31 18.06 4.31ZM17.53 7.21H7.22V5.36H17.53V7.21Z"
      fill="black"
    />
    <path
      d="M6.7 16.99H8.64C8.93 16.99 9.17 16.75 9.17 16.46C9.17 16.17 8.93 15.93 8.64 15.93H6.7C6.41 15.93 6.17 16.17 6.17 16.46C6.17 16.75 6.41 16.99 6.7 16.99Z"
      fill="black"
    />
    <path
      d="M11.84 13.03H6.7C6.40729 13.03 6.17 13.2651 6.17 13.555C6.17 13.8449 6.40729 14.08 6.7 14.08H11.84C12.1327 14.08 12.37 13.8449 12.37 13.555C12.37 13.2651 12.1327 13.03 11.84 13.03Z"
      fill="black"
    />
  </svg>
</template>

<script>
export default {
  name: 'NewsIcon',
};
</script>
